var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPencil({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.756,
    height: 24.754,
    viewBox: "0 0 24.756 24.754",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill_4",
    "data-name": "Fill 4",
    d: "M297.267,241.53l-14.752,14.814a4.056,4.056,0,0,1-2.822,1.163h-5.149a1.052,1.052,0,0,1-.745-.308,1.033,1.033,0,0,1-.286-.745l.131-5.2a3.956,3.956,0,0,1,1.161-2.723l10.453-10.473a.471.471,0,0,1,.657,0l3.666,3.652a1.392,1.392,0,0,0,.963.4,1.447,1.447,0,0,0,1.447-1.447v0a1.474,1.474,0,0,0-.394-1.01c-.065-.088-3.556-3.562-3.556-3.562a.586.586,0,0,1,0-.812l1.467-1.494a3.459,3.459,0,0,1,4.895-.013l.014.013,2.849,2.854a3.491,3.491,0,0,1,0,4.9",
    transform: "translate(-273.513 -232.754)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPencil);
export default __webpack_public_path__ + "static/media/icon-pencil.62ca016d7b6a4f5b76d5c6532f5f07f4.svg";
export { ForwardRef as ReactComponent };